import React from "react";
import styled from "styled-components";
import { Phone } from "../svgs";

const StyledText = styled.p`
  font-size: ${({ size }) => `${size}px`};
  align-self: center;
  text-align: ${({ align }) => align};
  line-height: ${({ height }) => `${height}px`};
  color: ${({ color }) => color};
  margin: ${({ margin }) => `${margin}px`};
  /* font-family: "Roboto Mono", monospace; */
  font-family: "MTNBold";
  font-weight: ${({ fontFamily }) => fontFamily};
  letter-spacing: ${({ letterSpacing }) =>
    letterSpacing ? `${letterSpacing}px` : "normal"};
`;

const RateBoxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
  margin-top: 10px;

  @supports (grid-template-columns: repeat(auto-fill, minmax(150px, 1fr))) {
    grid-template-columns: repeat(5, 1fr);
  }
`;

const Span = styled.span`
  font-size: ${({ size }) => `${size}px`};
  align-self: center;
  text-align: ${({ align }) => align};
  line-height: ${({ height }) => `${height}px`};
  color: ${({ color }) => color};
  margin: ${({ margin }) => `${margin}px`};
  /* font-family: "Roboto Mono", monospace; */
  font-family: "MTNBold";
  font-weight: ${({ fontFamily }) => fontFamily};
  letter-spacing: 0.5px;
`;

const Back = styled.div`
  display: grid;
  grid-auto-flow: column;
  height: 30px;
  width: 78px;
  padding: 5px;
  align-content: center;
  justify-content: space-around;
  position: relative;
  border-radius: 20px;
  top: 10px;
  left: 12px;
  background-color: #e31c79;
`;

const Border = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: flex-start;
  border: ${({ hasError }) =>
    hasError ? "1px solid #e31c79" : "1px solid black"};
  height: 55px;
  border-radius: 10px;
  padding-left: 8px;
  margin-top: ${({ marginTop }) => `${marginTop}px`};
`;

const TextInput = ({ hasIcon, hasError, marginTop, placeholder, cb }) => (
  <Border hasError={hasError} marginTop={marginTop}>
    {hasIcon && <Phone />}
    <UnstyleInput
      maxLength={10}
      size={20}
      type="text"
      pattern="\d*"
      onChange={(event) => cb(event.target.value)}
      placeholder={placeholder}
    />
  </Border>
);

const UnstyleInput = styled.input`
  width: 100%;
  margin: 0;
  height: 45px;
  border: 0px solid transparent;
  border-radius: 10px;
  outline: none;
  margin-left: 8px;
  padding: 5px;
  font-family: "Roboto Mono", monospace;
  font-weight: 300;
  ::placeholder {
    color: black;
    font-size: 14px;
    /* font-family: "Roboto Mono", monospace; */
    font-family: "MTNBold";
    font-weight: 100;
  }
`;

const Button = styled.div`
  display: grid;
  justify-content: space-around;
  background-color: ${({ disabled, color }) => (disabled ? "#C8CBCB" : color)};
  border-radius: 30px;
  margin: ${({ margin }) => `${margin}px`};
`;

const CurveHolder = styled.div`
  width: 100%;
  margin: 0px;
  margin-top: ${({ top }) => (top ? `${top}px` : `-40px`)};
`;

const DynamicButton = ({
  label,
  onClick = () => {},
  color,
  variant = "contained",
  disabled = false,
  fullWidth = false,
  textColor,
  startIcon,
  endIcon,
  padding = "20px 10px",
  height = "35px",
  width = "100%",
  labelCenter,
}) => {
  const buttonStyle = {
    height,
    position: "relative",
    padding,
    border: `2px solid ${disabled ? "#c8cbcb" : color}`,
    width,
    boxSizing: "border-box",
    justifyContent:
      (startIcon != null || endIcon != null) && !labelCenter
        ? "left"
        : "center",
    alignItems: "center",
    alignSelf: "center",
    display: "flex",
    cursor: "pointer",
    color: textColor,
  };
  return (
    <div>
      <ButtonHolder
        style={{
          maxWidth: fullWidth ? "100%" : "280px",
        }}
      >
        <Button
          disabled={disabled}
          onClick={() => {
            if (!disabled) onClick();
          }}
          style={buttonStyle}
          color={variant === "outlined" ? "#fff" : color}
        >
          {startIcon && <StartIconHolder>{startIcon}</StartIconHolder>}
          <StyledText
            style={{ fontFamily: "MTNMedium" }}
            size={14}
            color={textColor || (variant === "outlined" ? color : "#fff")}
          >
            {label}
          </StyledText>
          {endIcon && <EndIconHolder>{endIcon}</EndIconHolder>}
        </Button>
      </ButtonHolder>
    </div>
  );
};

const ButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 280px;
  margin: 10px auto;
`;

// New
const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: auto;
  scrollbar-width: none;
  position: relative;
  background-color: ${({ activeTheme }) => activeTheme};
  height: 700px;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const StartIconHolder = styled.div`
  margin-right: 10px;
`;

const EndIconHolder = styled.div`
  position: absolute;
  right: 5px;
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Body = styled.div`
  padding: 10px;
`;

const NotesContainer = styled.div`
  display: flex;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
  padding-left: 0;
  margin-top: 1px;
`;

const Dot = styled.div`
  width: 14px;
  height: 14px;
  border-radius: 14px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const FooterImageContainer = styled.div`
  width: 100%;
  height: 250px;
  overflow: hidden;
  margin-top: -43px;
`;

const FooterImage = styled.img`
  width: 100%;
  height: 216px;
  object-fit: cover;
  object-position: center top;
  margin: 36px -35px 0 0;
  /* position: absolute; */
`;

const FooterContainer = styled.div`
  background-color: ${({ activeTheme }) => activeTheme};
  padding: 20px;
  margin-top: -20px;
`;

const TipsContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

const TipContainer = styled.div`
  box-sizing: border-box;
  width: 125px;
  height: 120px;
  border-radius: 10px;
  background-color: white;
  padding: 10px;
  margin-right: 10px;
`;

const Divider = styled.div`
  height: 2px;
  background-color: black;
  margin-top: 3px;
`;

const StyledTextInput = styled.input`
  padding: 10px;
  outline: none;
  font-family: MTNRegular;
  border: 1px solid #999;
  border-radius: 7px;
  min-width: 200px;
  width: 80%;
  text-align: center;
`;

export {
  StyledText,
  Back,
  Span,
  TextInput,
  Button,
  CurveHolder,
  DynamicButton,
  MainHolder,
  Children,
  Body,
  NotesContainer,
  CircleContainer,
  Dot,
  FooterImageContainer,
  FooterImage,
  FooterContainer,
  TipsContainer,
  TipContainer,
  Divider,
  StyledTextInput,
  RateBoxContainer,
};
